import { TextField } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './attributeFilterGroup.module.css';

const styles = {
  label: {
    color: colors.neutral.dim,
  },
};

interface Props {
  value: {
    from?: number;
    to?: number;
  };
  label: string;
  onChange: (value: any) => void;
  unit: string;
  currency?: boolean;
}

const NumberRangeFilter = ({
  value,
  label,
  onChange,
  unit,
  currency,
}: Props) => {
  const handleChange = (property: string, newValue: any) => {
    const mappedValue = newValue === '' ? '' : parseFloat(newValue);
    onChange({
      ...value,
      [property]: mappedValue,
    });
  };

  return (
    <div>
      <div className={classes.rangeLabel}>{label}</div>
      <div className={classes.inputContainer}>
        <TextField
          value={value?.from || ''}
          onChange={event => handleChange('from', event.target.value)}
          type="number"
          variant="standard"
          slotProps={{
            inputLabel: { style: styles.label },
            input: {
              ...(currency && { startAdornment: '$' }),
              ...(unit && { endAdornment: <span>{unit}</span> }),
            },
          }}
        />
        <span className={classes.attributeRangeSpacer}>to</span>
        <TextField
          value={value?.to || ''}
          onChange={event => handleChange('to', event.target.value)}
          type="number"
          variant="standard"
          slotProps={{
            input: {
              ...(currency && { startAdornment: '$' }),
              ...(unit && { endAdornment: <span>{unit}</span> }),
            },
          }}
        />
      </div>
    </div>
  );
};

export default NumberRangeFilter;
